import { IconLoader } from '@ui/src';

import cn from '../styles.module.css';

const formatBeneficiaryDocumentsList = (
  list: {
    id: string;
    documentCategoryId: string;
    name: string;
    uploadId: string;
    render?: Record<string, React.JSX.Element>;
  }[],
  documentsCategories: { id: string; name: string }[],
  documentIsLoading?: boolean,
  documentIsFetching?: boolean,
  selectedDocumentId?: string,
): {
  id: string;
  documentCategoryId: string;
  name: string;
  uploadId: string;
  render?: Record<string, React.JSX.Element>;
}[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    const render: Record<string, React.JSX.Element> = {
      name: <div>{result.name}</div>,
      documentCategoryId: (
        <div className={cn.documentCategory}>
          {
            documentsCategories?.find(
              (category) => category.id === result.documentCategoryId,
            )?.name
          }
          {(documentIsLoading || documentIsFetching) &&
            selectedDocumentId === result.id && (
              <IconLoader
                width={20}
                height={20}
                className={cn.downloadDocumentLoader}
              />
            )}
        </div>
      ),
    };

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatBeneficiaryDocumentsList;
